import { Bleed, Divider } from '@shopify/polaris'

export const FullWithCardDivider = () => {
  return (
    <Bleed marginInline="400">
      <Divider />
    </Bleed>
  )
}
